
/**
 * Created by JasonChou on 16/12/12.
 */

import Vue from 'vue'
import {
  switchNode,
  moveNodeAsLastNode,
  oppositeAction,
  removeSelectControl,
  addSelectControl
} from 'utils/node.js'
import store from '../store';
import getId from 'utils/randomId.js'
import { scan } from 'utils/spider.js'
import {
  getCleanControl,
  getMiniControls,
  getCleanControlWithChildren,
  verify
} from 'utils/controlDetacher.js'

import {
  completePropsByDefine,
} from '../../utils/controlUtils'

import {
  post_statistics
} from '../../apis/statistics_apis'

const state = {
  errorStacks: [],
  controls: [],
  controlsMap: {},
  heartHistory: {},
  selectedControls: [],
  copyControls: [],
  widgets: [],
  childrenIds: [],
  // originControls: [],
  pageInfo: null,
  extra: {},
  modify: false,
  width: 900,
  height: 1000,
  selectedControlModel: null,
  selectedControlModelOffset: null,
  selectedControlModelDefaultValue: null,

  latestSaveTime: 0,
  saveStatus: 'saved',
  modifiedControls: {},
  heartbeatControls: {},

  //对控件进行撤销的数组
  cancelSelectedControlOps: [],
  //对控件进行重做的数组
  resumeSelectedControlOps: [],

  draggingControl: null,
  errControlId: "",
  //显示页面设置模态框
  showSetModal: false,
};

const maxOperationStackLength = 10;

const ADD_OPERATION = 'add';
const UPDATE_OPERATION = 'update';
const KEY_CHANGE_OPERATION = 'change';
const DELETE_OPERATION = 'delete';
const DRAG_CHANGE_OPERATION = 'drag_change';
const DRAG_EXCHANGE_OPERATION = 'drag_exchange';
const DRAG_MOVE_APPEND_OPERATION = 'drag_append_to_another';
let strackObj = [];
let strackKey = '';
let strackValue = '';
let appId = "";
let projectId = "";
let pageId = "";
import {
  controlsIsSameParent,
  newControlHelper,
  genNonDuplicateID
} from 'utils/controlUtils'
function recordModifiedControl (state, type) {
  let control = state.selectedControls[0]
  recordControlActions(state, control, type)
}


/**
 * 记录控件操作信息
 *
 * 2021-01-07 性能问题排查
 *
 * isRecurse 默认为 true ???
 */
function recordControlActions (state, control, type, isRecurse = true) {
  const updateStore = (control) => {
    state.modifiedControls[control.id] = control
    state.heartbeatControls[control.id] = control
  }
  if (control && control.id) {
    control = getCleanControl(control, isRecurse);
    control.operateType = type || 'modify'
    const types = ['modify', 'delete']

    const lastModifiedControl = state.modifiedControls[control.id]
    // 处理同一控件同时操作的行为
    if (lastModifiedControl && lastModifiedControl.operateType === 'add') {
      if (!control._id) {
        if (control.operateType === 'modify') {
          control.operateType = 'add'
          updateStore(control)
          return
        } else if (control.operateType === 'delete') {
          delete state.modifiedControls[control.id]
          delete state.heartbeatControls[control.id]
          return
        } else {
        }
      }
    }
    // 强制同步 modify的时候 添加样式
    if (control.operateType === 'modify' && !control._id && control.id) {
      const origin = state.controlsMap[control.id]
      if (origin && origin._id) {
        control._id = origin._id
      }
    }
    // 处理_id存在的情况，_id只有删除和修改
    if (control._id && control.operateType === 'add') {
      control.operateType = 'modify'
    }

    updateStore(control)
    // console.log('[record] ', state.modifiedControls)
  }
}

function saveChildren (state, control) {
  if (control.children) {
    for (const item of control.children) {
      item.parentId = control.id;
      item.childrenIds = [];
      if (item.children) {
        for (const children of item.children) {
          item.childrenIds.push(children.id);
        }
      }
      recordControlActions(state, item, 'add');
      saveChildren(state, item);
    }
  }
  return '';
};


function removeModifiedControl (state, control) {
  if (control && control.id && state.modifiedControls[control.id]) {
    delete state.modifiedControls[control.id]
  }
}

function getModifiedInfo (map) {
  const L = [];
  for (let id in map) {
    const control = map[id];
    const childrenIds = control.childrenIds || [];
    const path = [];
    control.parentId && path.push(control.parentId);
    path.push(`[${control.id}]`);
    childrenIds.length && path.push(childrenIds);
    L.push(path.join(' => '));
  }
  return L;
}

function addStack (state, name) {
  if (name) {
    state.errorStacks.push(name)
    const info = getModifiedInfo(state.modifiedControls);
    // console.info('当前修改记录信息', info);
    verify(state.modifiedControls, state.controlsMap, state.childrenIds, name, state.errorStacks, function (message) {
      let v = new Vue()
      setTimeout(v.$Message.error(message), 2000)
    }, state.pageInfo.page_id, state.pageInfo.app_id);
  }
}

// 控件使用统计
function statistics (state, event) {
  let hash = window.location.hash.split("/");
  let app_id = hash[2];
  let page_id = hash[4].split("?")[0];
  let data = {
    type: state.selectedControls[0].type,
    name: state.selectedControls[0].name,
    control_id: state.selectedControls[0].id,
    page_id,
    app_id,
    event,
    eventTime: Date.now()
  }
  return data;
}

const mutations = {
  UPDATE_STYLES (state, style, reset = false) {
    let control = state.selectedControls[0]
    if (control) {
      if (reset) {
        control.style = {
          top: control.style.top,
          left: control.style.left,
          position: control.style.position
        }
        control.props.classStyle = []
      }
      for (let s in style) {
        control.style[s] = style[s]
        recordControlActions(state, control, 'modify')
      }
    }
  },
  ADD_STACK: addStack,
  CLEAR_STACK (state) {
    state.errorStacks = []
  },
  ADD_ELEMENTS (state, elements, url) {
    // console.log(url)

    if (elements.length === 0) return
    state.copyControls = []
    const controls = Array.prototype.reduce.call(
      elements,
      (last, node, index) => {
        last = last.concat(scan(node, index, url, ''))
        return last
      },
      []
    )
    state.copyControls = controls
  },
  HEART_HISTORY (state, controls) {
    state.heartHistory = controls.reduce((last, control) => {
      if (control.id && !last[control.id]) {
        last[control.id] = []
      }
      last[control.id].push(control)
      return last
    }, {})
  },
  CLEAR_HEART_HISTORY (state) {
    state.heartHistory = {}
  },
  UPDATE_CHILDRENIDS (state, childrenIds) {
    state.childrenIds = childrenIds
  },
  CLEAR_MODIFIED_CONTROL (state) {
    state.modifiedControls = {}
  },
  RECORD_MODIFIED_CONTROL: recordModifiedControl,
  RECORD_CONTROL_ACTIONS: recordControlActions,
  CLEAR_HEARTBEAT_CONTROL (state) {
    state.heartbeatControls = {}
  },
  CHNAGE_CONTROL_SIZE (state, left, top, width, height, record = false) {
    state.selectedControls.map(control => {
      control.style['left'] = left
      control.style['top'] = top
      control.style['width'] = width
      control.style['height'] = height
    })
    state.modify = true
    if (record) {
      recordModifiedControl(state)
    }
  },

  START_DRAG (state, control) {
    state.draggingControl = control
  },

  SELECT_PAGE (
    state,
    {
      controlList,
      controlsMap,
      selectedControls = [],
      widgets = [],
      pageInfo = {},
      extra = {},
      childrenIds = []
    }
  ) {
    // TODO: controlsMap is always not updated successfully, so state.page.controls is in use first.
    if (controlList) {
      // state.originControls = getMiniControls(controlList)
      state.controls = controlList || []
    }
    if (childrenIds) {
      state.childrenIds = childrenIds || []
    }
    if (controlsMap) {
      state.controlsMap = controlsMap
    }

    state.widgets = widgets || []
    state.selectedControls = state.selectedControls || []

    state.cancelSelectedControlOps = []
    state.resumeSelectedControlOps = []
    state.latestSaveTime = 0
    state.extra = extra || {}

    state.pageInfo = pageInfo

    if (
      (pageInfo.layoutType === 1 && pageInfo.type == 0) ||
      (pageInfo.layoutType === 1 && pageInfo.type == 1)
    ) {
      state.width = 375
      state.height = 667
      state.pageInfo.width = 375
      state.pageInfo.height = 667
    } else if (
      pageInfo.layoutType === 1 &&
      pageInfo.type != 0 &&
      pageInfo.type != 1
    ) {
      state.width = 375
      state.pageInfo.width = 375
    }

    state.latestSaveTime = Date.now()
  },

  UPDATE_PAGE_INFO (state, info) {
    state.pageInfo = Object.assign(state.pageInfo, info)
  },

  SELECT_CONTROL_ITEMS (state, controls) {
    controls.forEach(control => {
      const index = state.selectedControls.findIndex(
        ctrl => control.controlId === ctrl.controlId
      )
      // console.log('index', index)
      if (index == -1) {
        control.style['z-index'] = 2000
        control.active = true
      }
    })
  },

  ADD_CONTROL_MAP (state, control) {
    state.controlsMap[control.id] = control
  },

  /**
   * 替换选中控件
   * @param state
   * @param controls
   * @constructor
   */
  UPDATE_SELECTED_CONTROLS (state, controls) {
    state.selectedControls.map(control => {
      control.active = false
      try {
        control.style['z-index'] = 10
      } catch (e) {
        console.info('style', control.style)
      }
    })

    state.selectedControls.map(control => {
      state.controls.map(item => {
        if (item == control) {
          item.active = false
          try {
            item.style['z-index'] = 10
          } catch (e) {
            console.info('style', item.style)
          }
          refreshControls(state, item)
        }
      })
    })

    const new_controls = []

    controls.map(control => {
      if (!control.style) {
        control.style = {}
      }
      control.style['z-index'] = 2000
      control.active = true
      const refreshControl = refreshControls(state, control)
      if (refreshControl) {
        new_controls.push(refreshControl)
      }
    })
    state.selectedControls = new_controls
  },

  /**
   * 新增一个控件
   * @param state
   * @param controlDefine
   * @param style
   * @param defineMaps
   * @constructor
   */
  NEW_CONTROL (
    state,
    controlDefine,
    style = {},
    defineMaps,
    isAddRecord = true
  ) {
    if (state.selectedControlModelDefaultValue)
      style = Object.assign(
        {},
        style,
        state.selectedControlModelDefaultValue.style
      )
    let control = newControlHelper(
      controlDefine,
      style,
      0,
      defineMaps,
      state.selectedControlModelDefaultValue.props,
      state.selectedControlModelDefaultValue.events,
      state.selectedControlModelDefaultValue.dataSource,
      `${controlDefine.type}${controlDefine.index}`
    )
    control.style.top -= state.selectedControlModelOffset.offsetY
    control.style.left -= state.selectedControlModelOffset.offsetX

    //将新增的控件操作加到撤销的栈中
    let oldSelectControls = []
    state.selectedControls.map(selControl => {
      oldSelectControls[oldSelectControls.length] = selControl
    })

    state.selectedControls.map(control => (control.active = false))
    state.selectedControls = [control]
    state.controls.push(control)
    state.controlsMap[control.id] = control

    let actionTyp = {
      item: control,
      actionType: ADD_OPERATION,
      selectValue: state.selectedControls,
      selectOldVal: oldSelectControls
    }

    operationCancel(state, actionTyp)

    const __recordActions = ctrl => {
      recordControlActions(state, ctrl, 'add')
      if (Array.isArray(ctrl.children)) {
        ctrl.children.forEach(__recordActions)
      }
    }

    if (isAddRecord) {
      __recordActions(control)
    }
    addStack(state, 'NEW_CONTROL')
    let data = statistics(state, 'add')
    post_statistics(data)
  },

  /**
   * 新增控件数组
   * @param state
   * @param controls
   * @constructor
   */
  NEW_CONTROLS (state, controls, isSaveToSelected = true) {
    state.selectedControls.map(control => {
      control.active = false
      control.style['z-index'] = 10
      return refreshControls(state, control)
    })

    state.selectedControls = []

    let tempControls = []
    for (let i = 0; i < controls.length; i++) {
      let control = controls[i]
      control.style.top = control.style.top || -control.style.offsetY
      control.style.left = control.style.left || -control.style.offsetX

      //将新增的控件操作加到撤销的栈中
      let oldSelectControls = []
      state.selectedControls.map(selControl => {
        oldSelectControls[oldSelectControls.length] = selControl
      })

      let hasControlIndex = -1
      state.controls.map((selControl, i) => {
        if (selControl.id == control.id) {
          hasControlIndex = i
          state.controls.splice(i, 1, control)
        }
      })
      if (hasControlIndex === -1) state.controls.push(control)

      state.controlsMap[control.id] = control
      tempControls.push(control)
      control.childrenIds = []
      if (control.children) {
        for (const item of control.children) {
          control.childrenIds.push(item.id)
        }
      }
      recordControlActions(state, control, 'add')
      saveChildren(state, control)

      let actionTyp = {
        item: control,
        actionType: ADD_OPERATION,
        selectValue: state.selectedControls,
        selectOldVal: oldSelectControls
      }

      operationCancel(state, actionTyp)
    }
    if (tempControls.length && isSaveToSelected) {
      tempControls.map(toControl => {
        let isExist = state.selectedControls.find(
          control => toControl == control
        )
        if (!isExist) {
          toControl.active = true
          const refreshControl = refreshControls(state, toControl)
          if (refreshControl) {
            state.selectedControls.push(refreshControl)
          }
        }
      })
    }
    addStack(state, 'NEW_CONTROLS')
  },

  SELECT_CONTROL_WITH_ID (state, controls) {
    controls.map(toControl => {
      let isExist =
        state.selectedControls.findIndex(
          control => toControl.id == control.id
        ) !== -1

      if (!isExist) {
        toControl.active = true
        const refreshControl = refreshControls(state, toControl)
        if (refreshControl) {
          state.selectedControls.push(refreshControl)
        }
      }
    })
    addStack(state, 'SELECT_CONTROL_WITH_ID')
  },

  /**
   * 追加选中控件
   * @param state
   * @param controls
   * @constructor
   */
  APPEND_SELECTED_CONTROLS (state, controls) {
    controls.map(toControl => {
      let isExist = state.selectedControls.find(control => toControl == control)

      if (!isExist) {
        toControl.active = true
        const refreshControl = refreshControls(state, toControl)
        if (refreshControl) {
          state.selectedControls.push(refreshControl)
        }
      }
    })
  },

  SYNC_CONTROLS (state, updateControlList = [], defineMaps) {
    // console.log('sync controls', updateControlList)
    let deleteControls = []
    // update reference

    function _merge (ctrl, control) {
      const keys = [...new Set(Object.keys(ctrl).concat(Object.keys(control)))]
      keys.forEach(k => {
        if (control[k]) {
          ctrl[k] = control[k]
        }
        if (!ctrl.define) {
          ctrl.define = defineMaps[ctrl.type]
        }
      })
      return ctrl
    }
    const syncFields = ['_id', 'hexCreateTime', 'hexUpdateTime']
    updateControlList.forEach(control => {
      syncFields.forEach(k => {
        if (state.controlsMap[control.controlId]) {
          Vue.set(state.controlsMap[control.controlId], k, control[k])
        }
      })
    })

    // 同步children, 确保children是正确的
    // let cache = {}
    // for (let c of updateControlList) {
    //   let ct = state.controlsMap[c.id]
    //   if (ct.childrenIds) {
    //     ct.children = ct.childrenIds.map(id => state.controlsMap[id])
    //   }
    // }
  },

  /**
   * 取消选中控件
   * @param state
   * @param toControl
   * @constructor
   */
  POP_SELECTED_CONTROLS (state, toControl) {
    let index = state.selectedControls.findIndex(
      control => toControl == control
    )

    if (index !== -1) {
      toControl.active = false
      state.selectedControls.splice(index, 1)
    }
  },
  /**
   * 更新自定义组件中的属性，属性从后端读
   * @param {*} state
   * @param {*} control
   * @param {*} k
   * @param {*} v
   */
  UPDATE_CUSTOM_ATTRS (state, control, k, v) {
    if (control.props.attrs[k]) {
      control.props.attrs[k] = v
    }

    state.modify = true
    recordControlActions(state, control, 'modify')
    addStack(state, 'UPDATE_CUSTOM_ATTRS')
  },

  UPDATE_CUSTOM_SRC (state, control, k, v) {
    control.props[k] = v
    state.modify = true
    recordModifiedControl(state, control, 'modify')
    addStack(state, 'UPDATE_CUSTOM_SRC')
  },

  /**
   * 更新自定义组件中的属性，属性从后端读
   * @param {*} state
   * @param {*} control
   * @param {*} k
   * @param {*} v
   */
  UPDATE_CUSTOM_STYLE (state, control, k, v) {
    const defaults = {
      width: 'auto',
      height: 'auto',
      top: 0,
      left: 0
    }
    // console.log('custom v', v)

    var empty = { undefined: 1, null: 1 }
    v = v * 1
    if (empty[v]) {
      v = defaults[k]
    }

    Vue.set(control.style, k, v)
    state.modify = true
    recordControlActions(state, control, 'modify')
    addStack(state, 'UPDATE_CUSTOM_STYLE')
  },

  /**
   * 清理选中
   * @param state
   * @constructor
   */
  CLEAR_SELECTED_CONTROLS (state) {
    state.selectedControls.map(control => {
      control.active = false
      control.style['z-index'] = 10
      return refreshControls(state, control)
    })
    state.selectedControls = []
  },

  /**
   * 删除选中控件
   * @param state
   * @constructor
   */
  REMOVE_SELECTED_CONTROLS (state) {
    let data = statistics(state, 'delete')
    post_statistics(data)
    const deleteCtrl = control => {
      if (Array.isArray(control.children) && control.children.length) {
        control.children.forEach(deleteCtrl)
      }
      recordControlActions(state, control, 'delete')
      if (state.controlsMap[control.id]) {
        delete state.controlsMap[control.id]
      }
    }
    state.lastSelectedControl = null
    state.selectedControls.map(control => {
      const siblings =
        control.parent && control.parent.children
          ? control.parent.children
          : state.controls
      const index = siblings.findIndex(c => c.id === control.id)
      if (index > -1) {
        siblings.splice(index, 1)
        deleteCtrl(control)

        // console.log('delete', control.parent)
        if (control.parent) {
          control.parent.childrenIds = control.parent.children.map(c => c.id)
          recordControlActions(state, control.parent, 'modify')
        }
      }
    })
    state.selectedControls = []
    addStack(state, 'REMOVE_SELECTED_CONTROLS')
  },

  /**
   * 删除控件数组
   * @param state
   * @constructor
   */
  REMOVE_SOME_CONTROLS (state, controls) {
    if (state.pageInfo.layoutType === 5) {
      controls.map(control => {
        const siblings =
          control.parent && control.parent.children
            ? control.parent.children
            : state.controls
        const index = siblings.findIndex(c => c.id === control.id)
        if (index > -1) {
          siblings.splice(index, 1)
          recordControlActions(state, control, 'delete')
        }
      })
    } else {
      controls.map(selControl => {
        state.controls.map((control, i) => {
          if (control.id == selControl.id) {
            state.controls.splice(i, 1)
            recordControlActions(state, control, 'delete')
          }
        })
      })
    }
    state.modify = true
    state.selectedControls = []
    recordModifiedControl(state)
    addStack(state, 'REMOVE_SOME_CONTROLS')
  },

  /**
   * 移动选中控件
   * @param state
   * @param type
   * @constructor
   */
  MOVE_SELECTED_CONTROLS (state, type) {
    let value = 0
    let attr

    if (type === 'left') {
      value = -5
      attr = 'left'
    } else if (type === 'right') {
      value = 5
      attr = 'left'
    } else if (type === 'top') {
      value = -5
      attr = 'top'
    } else {
      value = 5
      attr = 'top'
    }

    state.selectedControls.map(selControl => {
      selControl.style[attr] = parseInt(selControl.style[attr]) + value
      recordControlActions(state, selControl, 'modify')
    })

    let actionTyp = {
      actionType: KEY_CHANGE_OPERATION,
      selectControlValue: state.selectedControls,
      value: value,
      key: attr
    }

    operationCancel(state, actionTyp)
    addStack(state, 'MOVE_SELECTED_CONTROLS')
  },

  /**
   * 移动选中控件
   * @param state
   * @param x
   * @param y
   * @constructor
   */
  MOVE_TO_SELECTED_CONTROLS (state, x, y) {
    state.selectedControls.map(selControl => {
      selControl.style['position'] = 'absolute'
      selControl.style['left'] =
        parseInt(selControl.style['left']) + parseInt(x)
      selControl.style['top'] = parseInt(selControl.style['top']) + parseInt(y)
      recordControlActions(state, selControl, 'modify')
    })
    addStack(state, 'MOVE_TO_SELECTED_CONTROLS')
  },

  MOVE_END_SELECTED_CONTROLS (state, control, x, y) {
    let startX = parseInt(x)
    let startY = parseInt(y)

    let changeXValue = startX
    let changeYValue = startY
    let actionTyp = {
      actionType: DRAG_CHANGE_OPERATION,
      selectControlValue: state.selectedControls,
      key1: 'left',
      key2: 'top',
      offXValue: changeXValue,
      offYValue: changeYValue
    }
    recordModifiedControl(state)
    operationCancel(state, actionTyp)
    addStack(state, 'MOVE_END_SELECTED_CONTROLS')
  },
  SWITCH_CONTROL (state, node1, node2, nodes, updateIds = false, Vue) {
    switchNode(node1, node2, nodes, updateIds, state, recordControlActions, Vue)
    addStack(state, 'SWITCH_CONTROL')
  },

  // 爬虫布局交换的使用： 只用存两个变换的节点
  SWITCH_SPIDER_CONTROLS (state, node1, node2, nodes) {
    const obj = {
      actionType: DRAG_EXCHANGE_OPERATION,
      node1,
      node2,
      nodes
    }
    switchNode(node1, node2, nodes, false, state, recordControlActions)
    operationCancel(state, obj)
    addStack(state, 'SWITCH_SPIDER_CONTROLS')
  },
  // 爬虫布局添加状态下使用： 将节点node2 添加到另一个节点node1 的父亲节点的最后，（相当于appendChild移动）
  MOVE_NODE_AND_APPEND_NODE (state, node1, node2, nodes) {
    const obj = {
      actionType: DRAG_MOVE_APPEND_OPERATION,
      node1,
      node2,
      nodes
    }
    var actions = moveNodeAsLastNode(
      node1,
      node2,
      nodes,
      state,
      recordControlActions
    )
    removeSelectControl(state, actions.removeNode)
    addSelectControl(state, actions.addNode)

    obj.actions = actions
    operationCancel(state, obj)
    addStack(state, 'MOVE_NODE_AND_APPEND_NODE')
  },

  /**
   * 移动选中控件
   * @param state
   * @param control
   * @param x
   * @param y
   * @constructor
   */
  CHANGE_SELECTED_CONTROLS_SIZE (state, control, x, y, w, h) {
    let index = state.controls.findIndex(tcontrol => tcontrol == control)
    if (index !== -1) {
      state.controls[index].style['left'] =
        state.controls[index].style['left'] + x
      state.controls[index].style['top'] =
        state.controls[index].style['top'] + y
      state.controls[index].style['width'] =
        state.controls[index].style['width'] + w
      state.controls[index].style['height'] =
        state.controls[index].style['height'] + h
      addStack(state, 'CHANGE_SELECTED_CONTROLS_SIZE')
    }
  },

  SELECT_CONTROL_MODEL (state, selectedControlModel, offset, defaultValue) {
    if (selectedControlModel) {
      state.selectedControlModel = selectedControlModel
      state.selectedControlModelDefaultValue = defaultValue
      state.selectedControlModelOffset = offset
    } else {
      state.selectedControlModel = null
      state.selectedControlModelDefaultValue = null
      state.selectedControlModelOffset = {}
    }
    addStack(state, 'SELECT_CONTROL_MODEL')
  },

  SELECT_ALL_CONTROLS (state) {
    state.controls.map(control => (control.active = true))
    state.selectedControls = state.controls
    // console.log(state.controls)
    addStack(state, 'SELECT_ALL_CONTROLS')
  },

  COPY_SELECTED_CONTROLS (state) {
    let newControls = []
    state.selectedControls.map(selControl => {
      newControls[newControls.length] = selControl
    })

    state.copyControls = newControls
    addStack(state, 'COPY_SELECTED_CONTROLS')
  },

  // FIX: 这个新增的操作，不添加 recordModifiedControl(state)
  /**
   * @param {*} state
   * @param {*} defineMaps
   * 1. 复制的controls
   * 2. 选中的control 放在选中的control.parent最后
   */
  PASTE_SELECTED_CONTROLS (state, defineMaps) {
    let newControls = []
    state.selectedControls.map(control => {
      control.active = false
      control.style['z-index'] = 10
    })

    let newControlParent = null
    // selControl 复制的copy
    state.copyControls.map((selControl, i) => {
      let newControl
      let parent

      if (state.selectedControls.length && state.selectedControls[0].parent) {
        newControlParent = state.selectedControls[0].parent
      }

      newControl = getCleanControlWithChildren(selControl)

      delete newControl._id
      const top = parseFloat(newControl.style['top']) || 0
      const left = parseFloat(newControl.style['left']) || 0

      // 复制新控件偏移量10
      newControl.style['top'] = top + 10
      newControl.style['left'] = left + 10
      newControl.active = true
      newControl.style['z-index'] = 2000
      newControl.id = getId()
      newControl.controlId = newControl.id
      // 复制保持原来的 NAME
      newControl.name = selControl.name

      completePropsByDefine(newControl, defineMaps)
      newControl.childrenIds = newControl.children.map(item => item.id)
      replaceControlId(
        newControl,
        state.pageInfo.page_id,
        state.controlsMap,
        newControlParent,
        state,
        recordControlActions,
        'add'
      )
      newControls.push(newControl)
      state.modify = true
    })

    // 判断是否放到到父控件中
    if (
      newControlParent &&
      newControlParent.id &&
      Array.isArray(newControlParent.children)
    ) {
      const ids = newControls.map(item => item.id)
      newControlParent.children.push(...newControls)
      newControlParent.childrenIds.push(...ids)
      recordControlActions(state, newControlParent, 'modify')
    } else {
      state.controls.push(...newControls)
    }

    state.selectedControls = newControls
    addStack(state, 'PASTE_SELECTED_CONTROLS')
  },

  // fix: 这个是删除的操作，不添加 recordModifiedControl(state)
  CUT_SELECTED_CONTROLS (state) {
    let newCopy = []
    state.selectedControls.map(selControl => {
      newCopy[newCopy.length] = selControl
      state.controls.map((control, i) => {
        if (selControl.parent && selControl.parent.id) {
          deleteControlChildren(control, selControl, state)
        } else {
          if (control == selControl) {
            state.controls.splice(i, 1)
            recordControlActions(state, control, 'delete')
          }
        }
      })
    })
    state.selectedControls = []
    state.copyControls = newCopy
    state.modify = true
    addStack(state, 'CUT_SELECTED_CONTROLS')
  },

  UPDATE_SELECTED_CONTROL_NAME (state, name) {
    state.selectedControls[0].name = name
    state.modify = true
    recordModifiedControl(state)
    addStack(state, 'CUT_SELECTED_CONTROLS')
  },

  UPDATE_SELECTED_CONTROL_EVENT (state, event, value) {
    state.selectedControls[0]['events'][event] = value
    state.modify = true
    recordModifiedControl(state)
    addStack(state, 'UPDATE_SELECTED_CONTROL_EVENT')
  },

  UPDATE_SELECTED_CONTROL_EVENTS (state, event) {
    state.selectedControls[0]['events'] = event
    state.modify = true
    recordModifiedControl(state)
    addStack(state, 'UPDATE_SELECTED_CONTROL_EVENTS')
  },

  UPDATE_SELECTED_CONTROL_DS (state, value) {
    state.selectedControls[0]['dataSource'] = value
    state.modify = true
    addStack(state, 'UPDATE_SELECTED_CONTROL_DS')
  },
  UPDATE_SELECTED_CONTROL_OPTIONS (state, options) {
    state.selectedControls[0]['options'] = options
    state.modify = true
    recordModifiedControl(state)
    addStack(state, 'UPDATE_SELECTED_CONTROL_OPTIONS')
  },

  UPDATE_SELECTED_CONTROL_PROP (
    state,
    propKey,
    key,
    value,
    controlName,
    callback
  ) {
    if (controlName) {
      state.selectedControls[0] = state.controls.find(c => c.name == controlName)
    }
    if (!propKey || !key) return
    localStorage.setItem('endTime', Date.now())
    let oldValue
    if (propKey === 'complexEvents') {
      value = key
      oldValue = state.selectedControls[0][propKey] || []
      key = propKey
    } else {
      oldValue = state.selectedControls[0][propKey][key]
    }
    let props = state.selectedControls[0].props
    let controlId = state.selectedControls[0]._id
    let type = state.selectedControls[0].type
    if (oldValue !== value) {
      if (typeof value == 'object') {
        if (strackKey !== key && strackKey !== '') {
          strackObj = { [strackKey]: strackValue }
          appId = store.state.app.appInfo._id
          projectId = store.state.project.info._id
          pageId = store.state.page.pageInfo._id
          propsStrack(controlId, type, strackObj)
          strackKey = ''
          strackValue = ''
        } else if (strackKey == '') {
          strackKey = key
          if (value) strackValue = value.simple
          else strackValue = value
        } else if (strackKey == key) {
          if (value) strackValue = value.simple
          else strackValue = value
          strackObj = { [strackKey]: strackValue }
          localStorage.setItem('strackObj', JSON.stringify(strackObj))
        }
      } else {
        if (strackKey !== key && strackKey !== '') {
          strackObj = { [strackKey]: strackValue }
          appId = store.state.app.appInfo._id
          projectId = store.state.project.info._id
          pageId = store.state.page.pageInfo._id
          propsStrack(controlId, type, strackObj)
          strackKey = ''
          strackValue = ''
        } else if (strackKey == '') {
          strackKey = key
          strackValue = value
        } else if (strackKey == key) {
          strackValue = value
          strackObj = { [strackKey]: strackValue }
          localStorage.setItem('strackObj', JSON.stringify(strackObj))
        }
      }
    }
    if (key == 'formName') {
      if (value.length > 0) {
        props.placeholder = '请输入' + value
        state.selectedControls[0].name = value
        // console.log('value', value)
      } else {
        props.placeholder = ''
        state.selectedControls[0].name = ''
        // console.log('value', value)
      }
      props.requireString = props.placeholder
    }
    if (key == 'requireType') {
      if (value) {
        props.requireString = props.placeholder
      } else {
        props.requireString = ''
      }
    }
    if (propKey === 'complexEvents') {
      // console.log(propKey, value)
      Vue.set(state.selectedControls[0], propKey, value)
    } else {
      Vue.set(state.selectedControls[0][propKey], key, value)
    }

    let currentControl = state.selectedControls[0]

    if (oldValue != value) {
      let actionTyp = {
        item: currentControl,
        actionType: UPDATE_OPERATION,
        propsKey: propKey,
        key: key,
        value: value,
        oldVal: oldValue
      }

      operationCancel(state, actionTyp)
    }
    // TODO: 确保每次一定修改 不能放在 oldValue != value，部分场景下会相等，不会触发
    currentControl.childrenIds = currentControl.children.map(c => c.id)
    recordControlActions(state, currentControl, 'modify', false)
    state.modify = true
    addStack(state, 'UPDATE_SELECTED_CONTROL_PROP')
    typeof callback === 'function' && callback()
  },

  UPDATE_SELECTED_CONTROLS_PROP (state, propKey, key, value) {
    if (!propKey || !key) return

    state.selectedControls.map(item => {
      item[propKey][key] = value
      recordControlActions(state, item, 'modify', false)
    })

    state.modify = true
    addStack(state, 'UPDATE_SELECTED_CONTROLS_PROP')
  },

  SUPPER_SELECTED_CONTROLS_PROP (state, propKey, key, value) {
    if (!propKey || !key) return

    state.selectedControls.map(item => {
      if (item[propKey][key]) {
        let all = (item[propKey][key] + (' ' + value)).split(' ')
        all = new Set(all)
        all = [...all].join(' ')
        item[propKey][key] = all
      } else {
        item[propKey][key] = value
      }
      recordControlActions(state, item, 'modify')
    })

    state.modify = true
    addStack(state, 'UPDATE_SELECTED_CONTROLS_PROP')
  },

  //撤销操作 fix: 撤销比较特殊，撤销要判定，需要大量的测试，此处记录
  /**
   * 1. 撤销的控件是否存在
   * 2. 撤销后的属性和现有的是否一致
   *
   * 所以，撤销的时候 要进行上述步骤的验证逻辑，避免
   */

  CANCEL_SELECTED_CONTROL_OPERA (state) {
    if (state.cancelSelectedControlOps.length > 0) {
      let currentStatus = state.cancelSelectedControlOps.splice(
        state.cancelSelectedControlOps.length - 1,
        1
      )[0]
      //只是更改控件的属性
      if (currentStatus.actionType == UPDATE_OPERATION) {
        currentStatus.item[currentStatus.propsKey][currentStatus.key] =
          currentStatus.oldVal
      } else if (currentStatus.actionType == ADD_OPERATION) {
        //添加了一个控件
        state.controls.splice(state.controls.length - 1, 1)
        state.selectedControls = currentStatus.selectOldVal
      } else if (currentStatus.actionType == KEY_CHANGE_OPERATION) {
        //键盘移动了控件
        currentStatus.selectControlValue.map(selControl => {
          selControl.style[currentStatus.key] =
            selControl.style[currentStatus.key] - currentStatus.value
        })
      } else if (currentStatus.actionType == DELETE_OPERATION) {
        //删除控件
        currentStatus.deleteControlValue.map(deleteItem => {
          //插入原来的数据
          if (deleteItem.selectType == 'children') {
            state.controls.map(controls => {
              insertControlChildren(
                controls,
                deleteItem.indexValue,
                deleteItem.item,
                deleteItem.selectItem
              )
              state.selectedControls.splice(
                deleteItem.selectIndex,
                0,
                deleteItem.selectItem
              )
            })
          } else {
            state.controls.splice(deleteItem.indexValue, 0, deleteItem.item)
            state.selectedControls.splice(
              deleteItem.selectIndex,
              0,
              deleteItem.selectItem
            )
          }
        })
      } else if (currentStatus.actionType == DRAG_CHANGE_OPERATION) {
        //鼠标拖动移动控件
        currentStatus.selectControlValue.map(selControl => {
          selControl.style[currentStatus.key1] =
            selControl.style[currentStatus.key1] - currentStatus.offXValue
          selControl.style[currentStatus.key2] =
            selControl.style[currentStatus.key2] - currentStatus.offYValue
        })
      } else if (currentStatus.actionType == DRAG_EXCHANGE_OPERATION) {
        // 回到上一步
        switchNode(
          currentStatus.node2,
          currentStatus.node1,
          currentStatus.nodes
        )
      } else if (currentStatus.actionType == DRAG_MOVE_APPEND_OPERATION) {
      }

      if (state.resumeSelectedControlOps.length >= maxOperationStackLength) {
        state.resumeSelectedControlOps.splice(0, 1)
      }
      state.resumeSelectedControlOps.push(currentStatus)
      addStack(state, 'CANCEL_SELECTED_CONTROL_OPERA')
    }
  },

  // 重做的操作
  RESUME_SELECTED_CONTROL_OPERA (state) {
    if (state.resumeSelectedControlOps.length > 0) {
      let currentStatus = state.resumeSelectedControlOps.splice(
        state.resumeSelectedControlOps.length - 1,
        1
      )[0]

      //只是更改控件的属性
      if (currentStatus.actionType == UPDATE_OPERATION) {
        currentStatus.item[currentStatus.propsKey][currentStatus.key] =
          currentStatus.value
      } else if (currentStatus.actionType == ADD_OPERATION) {
        //添加了一个控件
        state.controls.push(currentStatus.item)
        state.selectedControls = currentStatus.selectValue
      } else if (currentStatus.actionType == KEY_CHANGE_OPERATION) {
        //移动了控件
        currentStatus.selectControlValue.map(selControl => {
          selControl.style[currentStatus.key] =
            selControl.style[currentStatus.key] + currentStatus.value
        })
      } else if (currentStatus.actionType == DELETE_OPERATION) {
        //删除控件
        currentStatus.deleteControlValue.map(deleteItem => {
          if (deleteItem.selectType == 'children') {
            state.controls.map(controls => {
              spliceControlChildren(
                controls,
                deleteItem.indexValue,
                deleteItem.item,
                deleteItem.selectItem
              )
              state.selectedControls.splice(deleteItem.selectIndex, 1)
            })
          } else {
            state.controls.splice(deleteItem.indexValue, 1)
            state.selectedControls.splice(deleteItem.selectIndex, 1)
          }
        })
      } else if (currentStatus.actionType == DRAG_CHANGE_OPERATION) {
        //鼠标拖动移动控件
        currentStatus.selectControlValue.map(selControl => {
          selControl.style[currentStatus.key1] =
            selControl.style[currentStatus.key1] + currentStatus.offXValue
          selControl.style[currentStatus.key2] =
            selControl.style[currentStatus.key2] + currentStatus.offYValue
        })
      } else if (currentStatus.actionType == DRAG_EXCHANGE_OPERATION) {
        switchNode(
          currentStatus.node2,
          currentStatus.node1,
          currentStatus.nodes,
          Vue
        )
      } else if (currentStatus.actionType == DRAG_MOVE_APPEND_OPERATION) {
        // TODO
      }
      if (state.cancelSelectedControlOps.length >= maxOperationStackLength) {
        state.cancelSelectedControlOps.splice(0, 1)
      }
      if (currentStatus.actionType !== DRAG_MOVE_APPEND_OPERATION) {
        state.cancelSelectedControlOps.push(currentStatus)
      }
    }
    addStack(state, 'RESUME_SELECTED_CONTROL_OPERA')
  },

  GROUP_SELECTED_CONTROLS (state, groupControlDefine) {
    //验证是否是在同一级
    if (!controlsIsSameParent(state.selectedControls)) return

    let first = state.selectedControls[0] //第一个选中的控件

    // 原来的父控件
    let parentControl = first.parent || {
      children: state.controls,
      id: ''
    }

    let firstIndex

    state.selectedControls.map((sControl, index) => {
      let i = parentControl.children.findIndex(item => sControl.id == item.id)
      if (!index) {
        firstIndex = i
      }
      parentControl.children.splice(i, 1) //待group对象从父控件中删除
    })
    //创建group控件
    let control = newControlHelper(
      // recordControlActions.bind(this, state),
      groupControlDefine,
      {
        left: first.style.left,
        top: first.style.top
      }
    )

    control.name = `div-${control.id.slice(0, 5)}`
    control.pageId = state.pageInfo.page_id
    //group插入到父控件,第一个选中控件原位置

    control.children = []
    control.childrenIds = []
    //添加父控件的设定
    control.parent = parentControl
    control.parentId = parentControl.id || ''

    parentControl.children.splice(firstIndex, 0, control)
    // 存储原有的父级修改
    if (parentControl.id) {
      parentControl.childrenIds = parentControl.children.map(c => c.id)
      recordControlActions(state, parentControl, 'modify')
    }

    state.selectedControls.map(item => {
      item.active = false
      item.parent = control
      item.parentId = control.id
      control.children.push(item) //包裹控件挂到新包裹控件下
      control.childrenIds.push(item.id)
      recordControlActions(state, item, 'modify')
    })

    state.selectedControls = [control]
    state.modify = true
    // 存储新增的父级
    recordControlActions(state, control, 'add')

    // 组合的时候将新增的control放到 controlsMap里
    if (!state.controlsMap[control.controlId]) {
      state.controlsMap[control.controlId] = control
    }
    addStack(state, 'GROUP_SELECTED_CONTROLS')
  },

  UN_GROUP_SELECTED_CONTROLS (state) {
    let groupControl = state.selectedControls[0]

    if (!groupControl || groupControl.type !== 'div') {
      return false
    }

    //从父控件删除group控件
    let parentControl = groupControl.parent || {
      children: state.controls
    }
    let groupIndex = parentControl.children.findIndex(
      item => groupControl == item
    )
    parentControl.children.splice(groupIndex, 1)
    // 删除原来的父级
    recordControlActions(state, groupControl, 'delete')

    groupControl.children.map((child, i) => {
      child.parent = groupControl.parent
      child.parentId = groupControl.parentId || ''
      recordControlActions(state, child, 'modify')
      parentControl.children.splice(groupIndex + i, 0, child)
    })
    parentControl.childrenIds = parentControl.children.map(item => item.id)

    // 更新选中的父控件
    recordControlActions(state, parentControl, 'modify')

    if (state.controlsMap[groupControl.controlId]) {
      delete state.controlsMap[groupControl.controlId]
    }

    state.selectedControls = []
    state.modify = true
    addStack(state, 'UN_GROUP_SELECTED_CONTROLS')
  },

  SAVE_PAGE_CONTROLS (state) {
    state.latestSaveTime = Date.now()
    addStack(state, 'SAVE_PAGE_CONTROLS')
  },

  CHANGE_SAVE_STATUS (state, status) {
    state.saveStatus = status
    addStack(state, 'CHANGE_SAVE_STATUS')
  },

  PAGE_UPDATE_MODIFY_FLAG (state, status) {
    state.modify = status
    state.realChange = 'PAGE_UPDATE_MODIFY_FLAG'
    addStack(state, 'PAGE_UPDATE_MODIFY_FLAG')
  },

  /**
   * 新增widget
   * controls 控件的列表
   * type : 1表示Form生成器 2表示块生成器
   * name widget名称
   */
  NEW_WIDGET (
    state,
    controls,
    tempBinding,
    bind,
    type,
    name,
    rows,
    columns,
    form_config,
    customStyleArr,
    thems,
    layout
  ) {
    if (type === 1) {
      let controlIds = []
      for (let i = 0; i < controls.length; i++) {
        controlIds.push(controls[i].id)
      }
      let widget = {
        controlIds,
        type,
        name,
        tempBinding: tempBinding || {},
        bind: bind || {},
        rows,
        columns,
        form_config,
        customStyleArr,
        thems,
        layout
      }
      widget.id = genNonDuplicateID(0)
      state.widgets.push(widget)
    } else if (type == 2) {
      let widget = {
        fatherControl: controls,
        form_config: form_config,
        type: type,
        name: name,
        tempBinding: tempBinding || {},
        bind: bind || {},
        rows: rows,
        columns: columns,
        customStyleArr: customStyleArr
      }
      widget.id = genNonDuplicateID(0)
      state.widgets.push(widget)
    }
    state.modify = true
  },

  /**
   * 修改widget
   * widget 需要修改的widget
   */
  UPDATE_WIDGET (state, widget) {
    let currentWidget = state.widgets.find(
      oneWidget => widget.id == oneWidget.id
    )
    state.widgets.splice(state.widgets.indexOf(currentWidget), 1, widget)
    state.modify = true
  },

  /**
   * 更换图片
   */
  UPDATE_IMAGE (state, image, key, setIndex) {
    let url = image.url.split('?x-oss')[0]
    if (!state.selectedControls[0].props[key]) {
      state.selectedControls[0].props[key] = []
    }
    state.selectedControls[0].props[key].splice(setIndex, 1, {
      url,
      _id: image._id,
      filename: image.showName,
      bucketName: image.bucketName
    })
    state.modify = true
    recordModifiedControl(state)
    addStack(state, 'UPDATE_IMAGE')
  },
  UPDATE_ERR_CONTROLID (state, value) {
    state.errControlId = value
  },
  UPDATE_SAVE_TIME (state, timeStamp) {
    const info = state.pageInfo
    if (info) info.hex_modify_time_stamp = timeStamp
  },
  SHOW_SET_MODAL (state, status) {
    state.showSetModal = status
  }
}
/**
 *  属性埋点调用接口
 */
function propsStrack (objectId, type, propsValue) {
  // console.log(projectId);
  Vue.prototype.$propsBuriedUsage("control", objectId, type, propsValue, "", "", projectId, appId, pageId).then(res => {
    // console.log(res);
  })
}
/**
 * 删除复合控件中的parent
 * @param control
 */
function deleteControlParent (control) {
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      delete item.parent;
      if (item.children && item.children.length) {
        deleteControlParent(item);
      }
    }
  }
}

/**
 *  删除某个control 的时候，遍历control的数组，然后将children中的此control删除
 */
function deleteControlChildren (control, destinationControl, state) {
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      if (item.id == destinationControl.id) {
        if (control.parent) {
          control.parent.children.splice(i, 1);
          control.parent.childrenIds = control.parent.children.map(c => c.id)
          recordModifiedControl(state, control.parent, 'modify', false)
        } else {
          state.controls.splice(i, 1);
          recordModifiedControl(state, control, 'delete')
        }
        return;
      }
      if (item.children && item.children.length) {
        deleteControlChildren(item, destinationControl, state);
      }
    }
  }
}

/**
 *  删除某个control 的时候，遍历control的数组，返回该子控件
 */
function getControlChildren (control, selControl) {
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      if (item.id == selControl.id) {
        let indexControl = {
          indexValue: i,
          item: control,
          selectType: 'children',
          selectItem: selControl
        };
        return indexControl;
      }
      if (item.children && item.children.length) {
        let res = getControlChildren(item, selControl);
        if (res) {
          return res;
        }
      }

    }
  }
}

/**
 *  删除某个control 的时候，遍历control的数组，插入之前的操作
 */
function insertControlChildren (control, index, itemControl, selControl) {
  if (control.id == itemControl.id) {
    control.children.splice(index, 0, selControl);
    return;
  }
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      if (item.id == itemControl.id) {
        item.children.splice(index, 0, selControl);
        return;
      }
      if (item.children && item.children.length) {
        insertControlChildren(item, index, itemControl, selControl);
      }
    }
  }
}

/**
 *  删除某个control 的时候，遍历control的数组，删除该操作
 */
function spliceControlChildren (control, index, itemControl, selControl) {
  if (control.id == itemControl.id) {
    control.children.splice(index, 1);
    return;
  }
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      if (item.id == itemControl.id) {
        item.children.splice(index, 1);
        return;
      }
      if (item.children && item.children.length) {
        spliceControlChildren(item, index, itemControl, selControl);
      }
    }
  }
}
function replaceControlId (control, page_id, controlsMap,
  parent, state, recordControlActions, type = 'modify') {
  parent = parent || {
    childrenIds: [],
    children: [],
    id: ''
  }
  const update = (control, page_id, parent, type) => {
    if (type === 'add') {
      // console.log('add')
      control.id = getId()
      control.controlId = control.id
      control._id && (delete control._id)
      if (!control.name) {
        control.name = `div-${control.id.slice(0, 5)}`
      }
    }
    control.parentId = parent.id
    control.parent = parent
    control.id = control.controlId
    if (page_id) {
      control.pageId = page_id
    }

    if (!controlsMap[control.id]) {
      controlsMap[control.id] = control
    }
  }

  update(control, page_id, parent, type)

  if (Array.isArray(control.children) && control.children.length) {
    control.children.forEach(ctrl => replaceControlId(ctrl, page_id, controlsMap, control, state, recordControlActions, type))
  }
  control.childrenIds = control.children.map(c => c.id)
  recordControlActions(state, control, type, false)
}


/**
 * 复合控件添加parent 并且修改style
 */
function pasteControlsAndAddParent (control, state, type = 'add') {
  let updateCtrl = (state, ctrl, type) => {
    if (type == 'add' && ctrl._id) {
      delete ctrl._id
    }
    ctrl.childrenIds = ctrl.children.map(c => c.id)
    if (state.controlsMap[ctrl.id]) {
      state.controlsMap[ctrl.id] = ctrl
    }
    // console.log('paste add', ctrl.id, type)
    recordControlActions(state, ctrl, type)
  }
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      item.parent = control;
      item.parentId = control.id
      item.id = getId();
      item.controlId = item.id
      let top = item.style['top']
      let left = item.style['left']
      if (parseFloat(top)) {
        top = parseFloat(top) + 10
      }
      if (parseFloat(left)) {
        left = parseFloat(left) + 10
      }
      item.style['top'] = top
      item.style['left'] = left

      updateCtrl(state, item, type)

      if (item.children && item.children.length) {
        pasteControlsAndAddParent(item, state, type);
      }
    }
    updateCtrl(state, control, type)
  }
}

/**
 * copy的复合控件需要添加parent
 * @param control
 */
function originalControlsAddParent (control, state, type) {
  if (control.children && control.children.length) {
    for (let i = 0; i < control.children.length; i++) {
      let item = control.children[i];
      item.parent = control;
      item.parentId = control.id
      if (item.children && item.children.length) {
        originalControlsAddParent(item, state, type);
      }
    }
  }
}

function operationCancel (state, operationType) {
  if (state.cancelSelectedControlOps.length >= maxOperationStackLength) {
    state.cancelSelectedControlOps.splice(0, 1);
  }
  state.resumeSelectedControlOps = [];
  state.cancelSelectedControlOps.push(operationType);
  state.modify = true;
}

/**
 * 刷新整个Controls树
 * @param state
 * @param control
 * @returns {*}
 */
function refreshControls (state, control) {
  let paths = findControlInTreePath({
    children: state.controls
  }, [], control);
  let new_control = null;
  if (paths) {
    let parentControl = {
      children: state.controls,
      childrenIds: state.controls.map(c => c.id)
    };
    paths.map((path, i) => {
      if (i < paths.length - 1) {
        parentControl = parentControl['children'][path];
      } else {
        new_control = Object.assign({}, parentControl['children'][path]);

        state.controlsMap[new_control.id] = new_control;

        parentControl.children.$set(path, new_control);
      }
    })
  }
  return new_control;
}

function findControlInTreePath (curr_control, paths, control) {
  if (curr_control.id === control.id) {
    return paths;
  }
  if (!curr_control.children) {
    return;
  }
  let res_paths = null;

  curr_control.children.some((child, i) => {
    let new_paths = paths.concat(i);
    let next_paths = findControlInTreePath(child, new_paths, control);

    if (next_paths) {
      res_paths = next_paths;
      return true;
    }
  });

  return res_paths;
}


export default {
  state,
  mutations,
  recordControlActions
}



// WEBPACK FOOTER //
// ./src/vuex/stores/page.js